import React from 'react';

const ShieldIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="68"
    height="68"
    fill="none"
    viewBox="0 0 68 68"
    className={props.className}
  >
    <path
      fill="#35C2A9"
      stroke="#35C2A9"
      d="M34 6c-.27 0-.602.13-.77.259C28.27 10.066 22.882 13 13.158 13a1.3 1.3 0 0 0-1.204.895C10.674 18.08 10 22.872 10 27.636c0 16.569 10.368 30.97 23.684 34.324.1.026.214.039.316.04.11.001.209-.012.316-.04C47.632 58.606 58 44.205 58 27.636c0-4.764-.673-9.555-1.954-13.741A1.3 1.3 0 0 0 54.842 13c-9.724 0-15.112-2.933-20.072-6.741-.273-.21-.5-.259-.77-.259z"
    />
    <path
      fill="#fff"
      stroke="#fff"
      d="M34 9c4.848 3.573 10.708 6.434 19.84 6.653 1.047 3.716 1.66 7.938 1.66 12.153 0 15.33-9.685 28.532-21.5 31.694-11.815-3.162-21.5-16.365-21.5-31.694 0-4.215.613-8.438 1.66-12.153C23.292 15.434 29.152 12.573 34 9z"
    />
  </svg>
);

export default ShieldIcon;
